// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Cause/index.css
// module id = 2634
// module chunks = 0